/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FavNotifications_favoriteNotificationsTiles$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Likes_viewer$ref: FragmentReference;
export type Likes_viewer = {|
  +favoriteNotifications?: ?{|
    +id: string,
    +hasNewEvents: ?boolean,
  |},
  +favoriteNotificationsTiles?: ?{|
    +$fragmentRefs: FavNotifications_favoriteNotificationsTiles$ref
  |},
  +$refType: Likes_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String"
  }
];
return {
  "kind": "Fragment",
  "name": "Likes_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNewEvents",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNotifications",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "favoriteNotificationsTiles",
          "name": "favoriteNotifications",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FavNotifications_favoriteNotificationsTiles",
              "args": [
                {
                  "kind": "Variable",
                  "name": "createdAfter",
                  "variableName": "createdAfter",
                  "type": null
                },
                {
                  "kind": "Variable",
                  "name": "eventsLimit",
                  "variableName": "eventsLimit",
                  "type": null
                },
                {
                  "kind": "Variable",
                  "name": "notificationItemsLimit",
                  "variableName": "notificationItemsLimit",
                  "type": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNewEvents",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoriteNotifications",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNewEvents",
              "args": [
                {
                  "kind": "Variable",
                  "name": "createdAfter",
                  "variableName": "createdAfter",
                  "type": "String"
                },
                {
                  "kind": "Variable",
                  "name": "eventsLimit",
                  "variableName": "eventsLimit",
                  "type": "Int"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f61435e6e8cad92af85cd8418309071f';
module.exports = node;
